import { useContext } from 'react'

import { type RegionSnapshotData } from '../firestore/regionCollection.ts'

import { RegionContext } from './RegionProvider.tsx'

export type { RegionSnapshotData } from '../firestore/regionCollection.ts'

export const useLoadingRegion = () => useContext(RegionContext)

export const useRegion: () => {
  readonly region: RegionSnapshotData
} = () => {
  const { region } = useContext(RegionContext)
  if (!region) throw new Error('Region is not available')
  return { region }
}
